export const checkoutStatusTypes = {
	PENDING: "PENDING",
	COMPLETED: "COMPLETED",
	CANCELLED: "CANCELLED",
};

export const cartStatusTypes = {
	OPEN: "OPEN",
	CLOSED: "CLOSED",
};

export const compliantStatusTypes = {
	COMPLIANT: "Compliant",
	NOTCOMPLIANT: "NotCompliant",
	NOT_COMPLIANT: "NotCompliantWithReason",
};

export const frequencyTypes = {
	YEARLY: "YEARLY",
	TWICE_YEARLY: "TWICE_YEARLY",
	THREE_TIMES_YEARLY: "THREE_TIMES_YEARLY",
	FOUR_TIMES_YEARLY: "FOUR_TIMES_YEARLY",
};

export const frequencyList = {
	YEARLY: "1 time Per Year",
	TWICE_YEARLY: "2 times per year",
	THREE_TIMES_YEARLY: "3 times per year",
	FOUR_TIMES_YEARLY: "4 times per year",
};
